import { Building2, Users, Award, TrendingUp } from "lucide-react";
import "@/styles/AboutSection.css";

const AboutSection = () => {
  const stats = [
    { icon: <Building2 size={32} />, value: "4+", label: "Años de Experiencia" },
    { icon: <Users size={32} />, value: "100+", label: "Clientes Satisfechos" },
    { icon: <Award size={32} />, value: "50+", label: "Proyectos Completados" },
    { icon: <TrendingUp size={32} />, value: "100%", label: "Compromiso" }
  ];

  return (
    <section className="about-section section-padding" data-testid="about-section">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="about-title" data-testid="about-title">Sobre Nosotros</h2>
            <div className="about-line"></div>
            <p className="about-description" data-testid="about-description">
              Pimot Construcciones nació en 2021 con una visión clara: elevar los estándares de calidad en la industria de la construcción en República Dominicana. Desde nuestros inicios nos comprometemos con la excelencia técnica, la puntualidad y la transparencia en cada proyecto.
            </p>
            <p className="about-description">
              Con trayectoria consolidada en obras residenciales, comerciales e institucionales, hemos construido más que estructuras: cimentamos relaciones de confianza duraderas.
            </p>
            <p className="about-description">
              Hoy seguimos creciendo con el mismo compromiso que nos dio origen: construir espacios que mejoren vidas.
            </p>
          </div>

          <div className="about-stats" data-testid="about-stats">
            {stats.map((stat, index) => (
              <div key={index} className="stat-card" data-testid={`stat-card-${index}`}>
                <div className="stat-icon">{stat.icon}</div>
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;